'use strict';

(function (global) {

  /**
   * Настройки предпросмотра для предпросмотра с картинками.
   *
   * @since 5.7.0
   */
  class ImageDocumentPreviewSettings extends global.BaseDocumentPreviewSettings {

    constructor() {
      super();
      this._previewScaleStorageName = `preview-${this.storageGroupName}-previewScale`;
    }

    /**
     * @see BaseDocumentPreviewSettings.defaultScale
     */
    static get defaultScale() {
      return 'a';
    }

  }

  global.ImageDocumentPreviewSettings = ImageDocumentPreviewSettings;

})(window.Core.preview);

